import { render } from "./InitializeAppError.vue?vue&type=template&id=70403ffb&scoped=true"
import script from "./InitializeAppError.vue?vue&type=script&setup=true&lang=js"
export * from "./InitializeAppError.vue?vue&type=script&setup=true&lang=js"

import "./InitializeAppError.vue?vue&type=style&index=0&id=70403ffb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70403ffb"],['__file',"src/components/errors/InitializeAppError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70403ffb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70403ffb', __exports__)) {
    api.reload('70403ffb', __exports__)
  }
  
  module.hot.accept("./InitializeAppError.vue?vue&type=template&id=70403ffb&scoped=true", () => {
    api.rerender('70403ffb', render)
  })

}


export default __exports__